import IMessageSource from './IMessageSource';

export default class WindowMessageSource implements IMessageSource {
    constructor(
        private readonly self: Window,
        private readonly receiver: Window,
    ) {}

    public sendMessage(data: string): void {
        this.receiver.postMessage(data, '*');
    }

    public setupMessageReceiver(receiver: (data: string) => void): void {
        this.self.addEventListener('message', (event: MessageEvent) => {
            if (event.source !== this.receiver || typeof event.data !== 'string') {
                return;
            }
            receiver(event.data);
        });
    }
}
